import ProfileStore from "../../../../stores/ProfileStore";

export const PPV_FILTERS_ENABLE_PART = true;
export const PPV_FILTERS_ENABLE_SUPPLIER = true;
export const PPV_FILTERS_ENABLE_CC_DESCRIPTION = true;
export const PPV_FILTERS_ENABLE_BU = false;

export const PPV_FILTERS_CACHED = true;

/**
 * If by default everything should be selected
 */
export const PPV_FILTER_DEFAULT_SELECT_ALL = true;

export function displayPpvVarianceKey(p: ProfileStore) {
    return `Same ${p.partDataName}`
}
